/**
 * The two widths the landing pages care about.
 *
 * They are different questions and deliberately different numbers:
 *
 *   PHONE_MAX_WIDTH        is the page LAYOUT breakpoint. Below it the header,
 *                          page padding, section gap, category row and contact
 *                          band take their phone values.
 *   STICKY_BAR_BREAKPOINT  is whether the fixed bottom call-to-action exists at
 *                          all. Wider than the layout breakpoint on purpose, so
 *                          a tablet in portrait gets the desktop layout AND the
 *                          sticky bar, which is what the design handoff asks
 *                          for.
 *
 * ⚠️ PHONE_MAX_WIDTH HAS A SECOND HOME. CSS cannot read a JavaScript constant,
 * so the number is also written into the `@media` query in `LandingPageV3.css`.
 * `landingBreakpoints.test.js` reads both files and fails if they disagree,
 * which is the only thing keeping them honest.
 *
 * WHY NOT `src/hooks/useIsMobile.js`, which also says 768. That hook answers a
 * different question: "is this a phone at all", UA sniffing included, and it
 * drives the whole-app mobile block in `App.js`. Importing it here, or this
 * there, would couple the campaign pages to that gate so that changing one
 * silently changes the other. The two are cross-referenced by comment and
 * nothing else.
 */

/**
 * The layout breakpoint, in CSS pixels.
 *
 * .98 rather than a round 639: fractional viewport widths are real (browser
 * zoom, Android density rounding), and a viewport of 639.5px would fall in the
 * gap between `max-width: 639px` and `min-width: 640px` and get neither set of
 * styles.
 */
export const PHONE_MAX_WIDTH = 639.98;

/** Below this, the fixed bottom call-to-action is in play. */
export const STICKY_BAR_BREAKPOINT = 768;
